import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {

	/**
	 * 屏幕列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	screenList( params={} ) {
		return request({
	    url: baseUrl + '/screen/index',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 屏幕修改
	**/
	screenEdit(id,data){
		return request({
			url: baseUrl + '/screen/editScreen/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 屏幕删除
	**/
	screenDel(id){
		return request({
			url: baseUrl + '/screen/delScreen/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 屏幕添加
	**/
	screenAdd(data){
		return request({
			url: baseUrl + '/screen/addScreen',
			method:'POST',
			data
		})
	},

	/**
	 * 屏幕控制
	 * screenId：屏幕id集合 
	 * type： 0是关 1是开
	**/
	screenContorl(data){
		return request({
			url: '/v1/screen/openOrCloseScreen',
			method:'POST',
			data
		})
	},

	/**
	 * 屏幕控制
	 * id：屏幕id集合 
	 * type： 0是关 1是开
	**/
	// screenContorl(data){
	// 	return request({
	// 		url: baseUrl + '/screen/closeScreen',
	// 		method:'POST',
	// 		data
	// 	})
	// },
}